import React from 'react';
import './report.css';

const ImageBlock = ({
  index,
  stateImages,
  removeImageFromState,
  limitSize,
  saveFileToState,
  setErrorText
}) => (
  <div className="image-list">
    <input
      className="spacing"
      style={{ display: 'none' }} // in css file doesn't work
      id={`img${index}`}
      type="file"
      accept="image/jpg, image/jpeg, image/png, image/bmp, image/tif, application/pdf"
      onChange={() => {
        const thisInput = document.getElementById(`img${index}`);
        if (thisInput.files[0]) {
          if (limitSize(thisInput.files[0].size)) {
            setErrorText('');
            saveFileToState(thisInput.files[0], index);
          } else {
            setErrorText('Files should be less than 10MB');
          }
        }
      }}
    />
    <i
      style={{
        display: stateImages[index] ? 'block' : 'none'
      }}
      className="fa fa-times delete-image"
      aria-hidden="true"
      onClick={() => {
        document.getElementById(`img${index}`).value = null; // removes file from input so onChange can be triggered
        removeImageFromState(index);
      }}
    />
    <img
      style={{
        display: stateImages[index] ? 'block' : 'none',
        height: '6em',
        width: '6em',
        borderRadius: "22px"
      }}
      className="spacing"
      id={`previewImg${index}`}
      src=""
      height="200"
      alt=""
    />
  </div>
);

export default ImageBlock;



// WEBPACK FOOTER //
// ./src/components/Report/ImageBlock.js